import { getObjValue } from 'utils/functions';

export const isFetchingTemplate = props => getObjValue(props, 'data.loading', true);
export const getTemplate = props => getObjValue(props, 'data.getTemplateById', null);
export const getTemplateActions = props => getObjValue(props, 'getTemplateDDEActions.getTemplateDDEActions', null);
export const isFetchingTemplateActions = props => getObjValue(props, 'getTemplateDDEActions.loading', true);
